import { CustomSlider } from "../CustomSlider/CustomSlider";
import { InputNumber } from "antd";
import "./SliderWithInput.less"

type SliderInputProps = {
    value: number;
    min: number;
    max: number;
    onChange: (a: number) => void;
    prcision?: number;
    step?: number;
    className?: string;
};

export const SliderWithInput = (props: SliderInputProps): React.ReactElement => {
    return <div className={`slider-with-input ${props.className || ""}`}>
        <CustomSlider value={props.value} onValueChange={props.onChange} min={props.min} max={props.max} step={props.step ?? 1}></CustomSlider>
        <InputNumber variant="borderless" type="number" controls={false} value={props.value} onChange={a => props.onChange(a as number)} min={props.min} max={props.max} precision={props.prcision ?? 0}></InputNumber>
    </div>;
};